import React, { FC } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Box,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';

export interface OrderFilterValues {
    customerName: string;
    address: string;
    creatorName: string;
    status: string;
    preferredStartDate: string;
    preferredEndDate: string;
    workStartDate: string;
    workEndDate: string;
    startDate: string;
    endDate: string;
}

interface OrderFilterDialogProps {
    open: boolean;
    onClose: () => void;
    onApply: () => void;
    onClear: () => void;
    filterValues: OrderFilterValues;
    setFilterValues: React.Dispatch<React.SetStateAction<OrderFilterValues>>;
    loading?: boolean;
}

const OrderFilterDialog: FC<OrderFilterDialogProps> = ({
    open,
    onClose,
    onApply,
    onClear,
    filterValues,
    setFilterValues,
    loading = false,
}) => {
    // ステータスの選択肢
    const statusOptions = [
        { value: "", label: "すべて" },
        { value: "対応済み", label: "対応済み" },
        { value: "未対応", label: "未対応" },
        { value: "進行中", label: "進行中" },
        { value: "保留", label: "保留" },
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    詳細絞り込み
                    <Button
                        startIcon={<Refresh />}
                        onClick={onClear}
                        size="small"
                        variant="outlined"
                    >
                        クリア
                    </Button>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box py={2}>
                    <Grid container spacing={2}>
                        {/* 1行目 */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="顧客名"
                                value={filterValues.customerName}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        customerName: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="顧客名を入力"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="住所"
                                value={filterValues.address}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        address: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="住所を入力"
                            />
                        </Grid>

                        {/* 2行目 */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="作成者"
                                value={filterValues.creatorName}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        creatorName: e.target.value,
                                    }))
                                }
                                fullWidth
                                placeholder="作成者名を入力"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>ステータス</InputLabel>
                                <Select
                                    value={filterValues.status}
                                    label="ステータス"
                                    onChange={(e) =>
                                        setFilterValues((prev) => ({
                                            ...prev,
                                            status: e.target.value,
                                        }))
                                    }
                                >
                                    {statusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* 3行目 - 希望日期間 */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="希望開始日（以降）"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={filterValues.preferredStartDate}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        preferredStartDate: e.target.value,
                                    }))
                                }
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="希望終了日（以前）"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={filterValues.preferredEndDate}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        preferredEndDate: e.target.value,
                                    }))
                                }
                                fullWidth
                            />
                        </Grid>

                        {/* 4行目 - 作業日期間 */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="作業開始日（以降）"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={filterValues.workStartDate}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        workStartDate: e.target.value,
                                    }))
                                }
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="作業終了日（以前）"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={filterValues.workEndDate}
                                onChange={(e) =>
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        workEndDate: e.target.value,
                                    }))
                                }
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    キャンセル
                </Button>
                <Button
                    variant="contained"
                    onClick={onApply}
                    disabled={loading}
                >
                    {loading ? "検索中..." : "適用"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OrderFilterDialog;